import { FormVue } from "./index.js";

(window as any).FormVueContact = FormVue;

export { FormVue };
export type { FormVueContactOptions } from "../shared/schema-types.js";
export type { ContactConfig } from "../shared/types.js";
